/**
 * Finds and returns the trip grouping that matches the specified criteria.
 *
 * @param {Array} tripGroupings - An array of trip grouping objects.
 * @param {string} groupNumber - The group number to match.
 * @param {string} coverageProgramIdentificationNumber - The coverage program identification number to match.
 * @param {string} requestedAppointmentReasonsClassification - The requested appointment reasons classification to match.
 * @param {string} medicarePlanCode - The medicare plan code to match.
 * @returns {Object} The trip grouping object that matches the specified criteria.
 * @throws {Error} If no trip grouping matches the specified criteria.
 */
export const getTargetTripGrouping = (
  tripGroupings,
  groupNumber,
  coverageProgramIdentificationNumber,
  requestedAppointmentReasonsClassification,
  medicarePlanCode,
) => {
  // Find the trip grouping that matches any specified criteria:
  // group number, coverage program identification number, or requested appointment reasons classification.
  const targetTripGrouping = tripGroupings.find(
    ({
      memberEnrollmentAttributes: {
        groupNumbers = [],
        coverageProgramIdentificationNumbers = [],
        medicarePlanCodes = [],
      } = {},
      staticGroupByAttributes: {
        requestedAppointmentReasonsClassifications = [],
      } = {},
    }) =>
      (!groupNumber || groupNumbers.includes(groupNumber)) &&
      (!coverageProgramIdentificationNumber ||
        coverageProgramIdentificationNumbers.includes(
          coverageProgramIdentificationNumber,
        )) &&
      (!requestedAppointmentReasonsClassification ||
        requestedAppointmentReasonsClassifications.includes(
          requestedAppointmentReasonsClassification,
        )) &&
      // TODO: Make sure the expected behavior as of now is:
      // IF there is medicare plan codes specified in the grouping definition, then it must match the specified medicare plan codes.
      // IF there is no medicare plan codes specified in the grouping definition, then it is a match.
      (!medicarePlanCodes?.length ||
        medicarePlanCodes.includes(medicarePlanCode)),
  );

  console.log('targetTripGrouping', targetTripGrouping);
  console.log('medicarePlanCode', medicarePlanCode);

  if (!targetTripGrouping) {
    throw Error(
      `Unrecognized coverage: group number = ${groupNumber}, program ID number = ${coverageProgramIdentificationNumber}, appointment reason classification = ${requestedAppointmentReasonsClassification}`,
    );
  }

  return targetTripGrouping;
};
